var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 13.2333L13.2333 12.05L15 13.825L16.7667 12.05L17.95 13.2333L16.175 15L17.95 16.7667L16.7667 17.95L15 16.175L13.2333 17.95L12.05 16.7667L13.825 15L12.05 13.2333ZM10 14.1667V12.5H5.83333V14.1667H10ZM14.1667 9.16667H5.83333V10.8333H12.2417C11.5522 11.2879 10.9864 11.9066 10.5951 12.6338C10.2038 13.3611 9.99934 14.1742 10 15C10 15.9083 10.2417 16.7667 10.6667 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.24167 3.24167 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V10.6667C16.7667 10.2417 15.9083 10 15 10L14.1667 10.0667V9.16667ZM14.1667 7.5V5.83333H5.83333V7.5H14.1667Z",
    fill: "#0001018a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelImport);
export default __webpack_public_path__ + "static/media/cancel_import.313908ac.svg";
export { ForwardRef as ReactComponent };